// extracted by mini-css-extract-plugin
export default {"splash-wrapper":"Splash_progress_splash-wrapper__mzQHQ"};